import React from "react";
import { Route, Switch } from "react-router-dom";
import CustomPages from "./CustomPages";
import CustomPage from "./CustomPage";

const GetTheLook = props => {
  return (
    <Switch>
      <Route exact path="/GettheLook" component={CustomPages} />
      <Route path="/GettheLook/:id" component={CustomPage} />
    </Switch>
  );
};

export default GetTheLook;
